import React, { useState } from 'react';
import { Container, Accordion, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { FaSearch, FaPaw, FaQuestionCircle } from 'react-icons/fa';
import faqData from './faqData'; // Make sure this path is correct

// Custom CSS remains the same
const faqStyles = `
  .faq-section {
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
  }
  .faq-section:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  }
  .accordion-button:not(.collapsed) {
    background: #fff5f5 !important;
    color: #dc3545 !important;
  }
  .faq-category-title {
    border-left: 4px solid #dc3545;
    padding-left: 1rem;
  }
`;

const FAQ = () => {
    const [searchTerm, setSearchTerm] = useState('');

    // Flatten all FAQs from categories for search
    const allFaqs = faqData.flatMap(category =>
        category.faqs.map(faq => ({ ...faq, categoryId: category.id }))
    );

    // Filter FAQs based on search term
    const filteredFaqs = allFaqs.filter(faq =>
        faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Group filtered FAQs by their original categories
    const groupedFaqs = faqData.map(category => ({
        ...category,
        faqs: filteredFaqs.filter(faq => faq.categoryId === category.id)
    })).filter(category => category.faqs.length > 0);

    return (
        <Container className="py-5">
            <style>{faqStyles}</style>

            {/* Search Bar - Remains the same */}
            <Row className="mb-5">
                <Col md={8} className="mx-auto">
                    <InputGroup className="shadow-lg rounded-pill">
                        <InputGroup.Text className="bg-white border-0">
                            <FaSearch className="text-muted" />
                        </InputGroup.Text>
                        <Form.Control
                            type="search"
                            placeholder="Search FAQs (e.g., 'rehome cat', 'adoption process')"
                            className="border-0 py-3"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputGroup>
                </Col>
            </Row>

            {/* FAQ Sections - Now using the original category structure */}
            {groupedFaqs.map(category => (
                <div key={category.id} className="mb-4">
                    <h3 className="faq-category-title mb-4">
                        <FaPaw className="me-2" />
                        {category.title}
                    </h3>

                    <Accordion defaultActiveKey="0" flush>
                        {category.faqs.map((faq, index) => (
                            <div key={`${category.id}-${index}`} className="faq-section mb-3 p-3 shadow-sm">
                                <Accordion.Item eventKey={`${category.id}-${index}`}>
                                    <Accordion.Header className="fw-semibold">
                                        <FaQuestionCircle className="me-2 text-danger" />
                                        {faq.question}
                                    </Accordion.Header>
                                    <Accordion.Body className="text-muted lh-lg">
                                        {faq.answer}
                                        {category.id === 'trust-safety' && (
                                            <div className="mt-3 p-3 bg-light rounded">
                                                <strong>Safety Tip:</strong> Always verify credentials through our secure portal.
                                            </div>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </div>
                        ))}
                    </Accordion>
                </div>
            ))}
        </Container>
    );
};

export default FAQ;